import { TournamentSegmentGroupBase } from "./TournamentSegmentGroup";

export type RoundsSegmentGroupBase = TournamentSegmentGroupBase & {
  roundPrefix: string;
  rounds: Round[];
};

export type Round = {
  matchIds: string[];
  nameOverride: string | undefined;
  roundNum: number;
};

export const getRoundName = (round: Round, prefix: string) => {
  if (!!round.nameOverride) {
    return round.nameOverride;
  }

  return `${prefix} ${round.roundNum}`;
};

export const getRoundsSegmentGroupMatchTitle = (
  group: RoundsSegmentGroupBase,
  matchId: string
) => {
  const round = group.rounds.find((r) => r.matchIds.includes(matchId));
  if (!round) {
    return undefined;
  }

  return getRoundName(round, group.roundPrefix);
};

export const getRoundMatchIds = (rounds: Round[], roundNum: number) => {
  return rounds.find((r) => r.roundNum === roundNum)?.matchIds;
};

export const getPreviousRoundsMatchIds = (
  rounds: Round[],
  roundNum: number
) => {
  return rounds.filter((r) => r.roundNum < roundNum).flatMap((r) => r.matchIds);
};
